import AbnerSimoes from "@/assets/img/jobs/logos/abnersimoes.svg";
import LenaMelo from "@/assets/img/jobs/logos/lena-melo.svg";
import ColetaSeletivaSFS from "@/assets/img/jobs/logos/cs-sfs.svg";
import WeCancer from "@/assets/img/jobs/logos/wecancer.svg";
import Geru from "@/assets/img/jobs/logos/geru.svg";
// import PartiuMundao from '@/assets/img/jobs/logos/partiu-mundao.png'
// import FocoBrasil from '@/assets/img/jobs/logos/foco-brasil.png'
import Jota3w from "@/assets/img/jobs/logos/jota3w.svg";
// import QMN from "@/assets/img/jobs/logos/quero-minha-nota.svg";
import RedNota1000 from "@/assets/img/jobs/logos/redacao-nota-1000.png";
import Acamed from "@/assets/img/jobs/logos/acamed.png";
import Nespresso from "@/assets/img/jobs/logos/nespresso.svg";
// import Odebrecht from '@/assets/img/jobs/logos/odebrecht.png'
// import AMC from '@/assets/img/jobs/logos/amc.png'

const aplha = ".8";

export default {
  namespaced: true,

  state: {
    content: {
      main:
        "Durante 8 anos de carreira trabalhando como desenvolvedor front-end, muito conhecimento e experiência foi adquirido. Para representar um pouco dessa trajetória separei alguns dos principais projetos que desenvolvi.",
      items: [
        {
          logo: {
            image: LenaMelo,
            type: "svg",
          },
          color: `rgba(243, 117, 138, ${aplha})`,
          job: "App Nativo & Design System",
          tags: ["Flutter", "Redux", "Open-wc", "Storybook", "Web Components", "Style Dictionary"],
          link: "https://lenamelo.com.br/",
        },
        {
          logo: {
            image: ColetaSeletivaSFS,
            type: "svg",
          },
          color: `rgba(61, 120, 251, ${aplha})`,
          job: "Site de consulta por serviço",
          tags: ["React", "Redux", "Gatsby", "GraphQL", "PWA", "Google Maps API"],
          link: "https://coletaseletivasantafedosul.com.br/",
        },
        {
          logo: {
            image: WeCancer,
            type: "svg",
          },
          color: `rgba(42, 168, 81, ${aplha})`,
          job: "App Nativo & Back Office",
          tags: ["React-Native & Expo", "React/Redux", "Typescript", "Ruby On Rails", "PostgreSQL", "GraphQL"],
          link: "https://wecancer.com.br/",
        },
        {
          logo: {
            image: Geru,
            type: "svg",
          },
          color: `rgba(0, 184, 215, ${aplha})`,
          job: "Aplicação web",
          tags: ["React/Redux", "Flow", "styled-components", "NextJS", "GraphQL", "Apollo", "Jest"],
          link: "https://www.geru.com.br/",
          // {
          //   logo: {
          //     image: PartiuMundao,
          //     type: 'png'
          //   },
          //   color: `rgba(40, 187, 253, ${aplha})`,
          //   job: 'Rede social',
          //   tags: [
          //     'Angular5',
          //     'NgRx',
          //     'Sass',
          //     'NodeJS',
          //     'MongoDB'
          //   ],
          //   link: 'http://www.partiumundao.com.br/'
          // },
        },
        // {
        //   logo: {
        //     image: FocoBrasil,
        //     type: 'png'
        //   },
        //   color: `rgba(0, 102, 185, ${aplha})`,
        //   job: 'Plataforma de indicadores',
        //   tags: [
        //     'React',
        //     'Redux',
        //     'PostCSS',
        //     'Webpack'
        //   ],
        //   link: 'http://www.focopedagogico.pa.gov.br/login'
        // },
        // {
        //   logo: {
        //     image: QMN,
        //     type: "svg",
        //   },
        //   color: `rgba(21, 120, 62, ${aplha})`,
        //   job: "Aplicativo Híbrido",
        //   tags: ["Ionic 3", "Sass", "PouchDB", "UI Design"],
        //   link: "https://play.google.com/store/apps/details?id=br.com.tuneduc.qmnion",
        // },
        {
          logo: {
            image: Jota3w,
            type: "svg",
          },
          color: `rgba(38, 38, 38, ${aplha})`,
          // color: `rgba(255, 216, 0, ${aplha})`,
          job: "Site institucional",
          tags: ["HTML5", "Jade", "Sass", "Grunt"],
          link: "https://www.jota3w.com.br/",
        },
        {
          logo: {
            image: RedNota1000,
            type: "png",
          },
          color: `rgba(22, 160, 133, ${aplha})`,
          job: "Plataforma EAD",
          tags: ["HTML5", "Sass", "CoffeeScript", "Grunt"],
          link: "https://www.redacaonota1000.com.br/",
        },
        {
          logo: {
            image: Acamed,
            type: "png",
          },
          color: `rgba(0, 185, 221, ${aplha})`,
          job: "Rede social",
          tags: ["HTML5", "Jade", "Sass", "Compass"],
          link: "https://acamed.com.br/",
        },
        {
          logo: {
            image: Nespresso,
            type: "svg",
          },
          color: `rgba(0, 0, 0, ${aplha})`,
          job: "Landing Page",
          tags: ["HTML5", "Jade", "Sass"],
          link: "http://www.nespresso.com/trophybrasil",
          // },{
          //   logo: {
          //     image: Odebrecht,
          //     type: 'png'
          //   },
          //   color: `rgba(227, 31, 43, ${aplha})`,
          //   job: 'Single Page Application (SPA)',
          //   tags: [
          //     'HTML5',
          //     'Sass',
          //     'Parallax',
          //   ],
          //   // link: '/portfolio/odebrecht'
          // },{
          //   logo: {
          //     image: AMC,
          //     type: 'png'
          //   },
          //   color: `rgba(49, 49, 49, ${aplha})`,
          //   job: 'Sistema CMS',
          //   tags: [
          //     'WordPress',
          //     'PHP',
          //     'MySQL',
          //     'HTML5',
          //     'Sass'
          //   ],
          //   link: 'http://amc.arq.br/'
        },
        {
          logo: {
            image: AbnerSimoes,
            type: "svg",
          },
          color: `rgba(34, 34, 34, ${aplha})`,
          job: "Portfólio PWA",
          tags: ["Vue 3", "Vuex", "Pug", "Sass", "UX Design", "UI Design"],
          // link: '/']
        },
      ],
    },
    navFooter: [
      {
        title: "Contato",
        url: "/contato",
        highlight: false,
      },
    ],
  },

  getters: {},

  mutations: {},

  actions: {},
};
